module.exports = __webpack_public_path__ + "static/media/logo_fesw.ec7b9061.svg";